/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceQueryLocation extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceQueryLocation");
    }

    getFixupPrototypeFunction() { return ResourceQueryLocation.fixupPrototype; }

    static newInstance(model: Partial<ResourceQueryLocation>): ResourceQueryLocation {
        let obj = Object.assign(new ResourceQueryLocation(), model);
        ResourceQueryLocation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceQueryLocation>): ResourceQueryLocation {
        if (!model) return null;
        return ResourceQueryLocation.newInstance(<ResourceQueryLocation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceQueryLocation) {
        if (!obj) return;

        models.ResourceQueryLocation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceQueryLocation): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceQueryLocation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Regions for the resources
     */
    regions: Array<string>;

}
